import { UploadStep } from './types';
import { StepSelectInvoices } from './StepSelectInvoices';
import { StepUploadStatus } from './StepUploadStatus';
import { useUploadUI } from './useUploadUI';

export const MainContent: React.FC = () => {
  const { activeStep } = useUploadUI();

  return (
    <div className='pt-20 px-24 pb-24 flex-1 overflow-y-auto'>
      {activeStep === UploadStep.Step1_SelectInvoice && <StepSelectInvoices />}
      {activeStep === UploadStep.Step2_UploadStatus && <StepUploadStatus />}
    </div>
  );
};
